import { render, staticRenderFns } from "./OcorrenciasTable.vue?vue&type=template&id=a3a34558&"
import script from "./OcorrenciasTable.vue?vue&type=script&lang=js&"
export * from "./OcorrenciasTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports